import React from 'react';
import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/layout/Panel'

export default class extends React.Component {
    render () {
        const data = {
            url: '/admin/carriers/carriers',
            data: {
                data: [],
                metadata: []
            },
            userFilterExpandable: true,
            userFilterSimple: true,
            userfilter:
                [
                    {
                        source: 'ATRCLIENTIDNUMBER',
                        label: 'Client ID',
                        type: 'text',
                        default: ''
                    },
                    {
                        source: 'ATRACCTNAME',
                        label: 'Name',
                        type: 'text',
                        default: ''
                    }
                ],
            onclick: 'link',
            link: '/carriers/carriers/{id}/edit',
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRCARRIERID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'Unique ID',
                        source: 'unique_id',
                        type: 'text',
                        editable: false,
                        visible: true
                    },
                    {
                        label: 'Name',
                        source: 'ATRNAME',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'name'
                    },
                    {
                        label: 'Currency',
                        source: 'ATRCURID',
                        type: 'select',
                        editable: false,
                        visible: true,
                        default: '1'
                    },
                    {
                        label: 'Balance',
                        source: 'ATRBALANCE',
                        type: 'money',
                        editable: false,
                        visible: true,
                        default: '0.00'
                    },
                    {
                        label: 'Credit Limit',
                        source: 'ATRCREDLIM',
                        type: 'money',
                        editable: true,
                        visible: true,
                        default: '0.00',
                        placeholder: '0.00'
                    },
                    {
                        label: 'Pay Terms',
                        source: 'payment_term_id',
                        type: 'select'
                    },
                    {
                        label: 'Reseller',
                        source: 'ATRRESELLERID',
                        type: 'select',
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'boolean',
                        editable: true,
                        visible: true,
                        default : true
                    },
                    {
                        label: 'Delete',
                        type: 'delete',
                    }
                ]
        }
        return (
            <Panel title = "Interconnects">
                <DataResource
                    addButtonText = "Create Interconnect"
                    addButtonLink = "/carriers/carriers/create"                    
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
   